import React, { useState } from 'react';
import ModalEdit from '../Components/ModalEdit';

const useOptions = () => {
  const edit = (data, close) => <ModalEdit data={data} close={close} />;

  return edit;
};

export default useOptions;
